function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M.502.058h20.187V19H.502z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M.468.53h19.434V24H.468z"
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M.11.327h19.755V21H.11z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M.501.327h19.221V21H.502z"
}), /*#__PURE__*/React.createElement("path", {
  id: "i",
  d: "M0 .327h19.755V21H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "k",
  d: "M.013.327h20.706V21H.013z"
}), /*#__PURE__*/React.createElement("path", {
  id: "m",
  d: "M.156.327H20.86V21H.156z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(63 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.736 1.664A10.55 10.55 0 0 0 16.06.286l-.019-.013c-.014-.01-.028-.02-.043-.028a1.279 1.279 0 0 0-.668-.187c-.714 0-1.292.581-1.292 1.3 0 .457.233.859.588 1.09.448.295.875.646 1.282 1.054 1.48 1.489 2.198 3.237 2.198 5.345 0 2.108-.719 3.856-2.198 5.343-1.48 1.489-3.217 2.212-5.313 2.212-2.096 0-3.833-.723-5.312-2.212-1.48-1.487-2.198-3.235-2.198-5.343s.719-3.856 2.198-5.345c.407-.408.834-.76 1.282-1.053.354-.232.588-.634.588-1.091 0-.719-.579-1.3-1.293-1.3-.244 0-.473.068-.668.187L5.15.273c-.006.004-.012.009-.02.013-.588.389-1.147.847-1.674 1.378C1.495 3.634.502 6.052.502 8.847s.993 5.213 2.952 7.183C5.414 18 7.816 19 10.595 19c2.78 0 5.182-1 7.141-2.97 1.96-1.97 2.953-4.388 2.953-7.183s-.994-5.213-2.953-7.183",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M73.5 10c-.828 0-1.5-.587-1.5-1.313V1.313C72 .587 72.672 0 73.5 0S75 .587 75 1.313v7.374C75 9.413 74.328 10 73.5 10"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(84)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.902 17.434c0-.707-.552-1.28-1.234-1.28-.487 0-.91.293-1.11.72l-.019.046-.012.03a7.397 7.397 0 0 1-1.537 2.325c-1.408 1.462-3.061 2.172-5.055 2.172h-.864c-1.994 0-3.647-.71-5.054-2.173-1.407-1.46-2.092-3.178-2.092-5.25v-2.883h6.9c.68 0 1.229-.572 1.229-1.276 0-.705-.55-1.277-1.229-1.277h-6.9V1.806c0-.705-.55-1.277-1.228-1.277-.679 0-1.23.572-1.23 1.277v12.219c0 2.747.946 5.121 2.81 7.057S7.427 24 10.071 24h.864c2.644 0 4.932-.984 6.801-2.926a9.972 9.972 0 0 0 2.087-3.18 1.34 1.34 0 0 0 .079-.46",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(127 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.532 13.652c-.48 0-.901.251-1.136.628a8.05 8.05 0 0 1-1.39 1.824c-1.527 1.515-3.32 2.25-5.481 2.25-2.162 0-3.955-.735-5.481-2.25-1.526-1.516-2.268-3.294-2.268-5.44 0-2.146.742-3.926 2.268-5.44 1.526-1.515 3.32-2.25 5.48-2.25 2.163 0 3.955.735 5.481 2.25a8.062 8.062 0 0 1 1.39 1.823c.236.377.657.628 1.137.628a1.329 1.329 0 0 0 1.162-1.978 10.951 10.951 0 0 0-1.796-2.356c-2.027-2-4.508-3.014-7.373-3.014-2.868 0-5.346 1.018-7.368 3.024C1.136 5.357.11 7.818.11 10.664s1.026 5.306 3.047 7.312C5.18 19.983 7.657 21 10.525 21c2.865 0 5.346-1.014 7.373-3.014a10.954 10.954 0 0 0 1.796-2.356 1.329 1.329 0 0 0-1.163-1.977",
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.424 13.652c-.467 0-.876.251-1.104.628a8.047 8.047 0 0 1-1.353 1.824c-1.485 1.515-3.23 2.25-5.333 2.25-2.104 0-3.848-.735-5.333-2.25-1.485-1.516-2.207-3.294-2.207-5.44 0-2.146.722-3.926 2.207-5.44 1.485-1.515 3.23-2.25 5.333-2.25 2.102 0 3.848.735 5.333 2.25a8.06 8.06 0 0 1 1.353 1.823c.228.377.637.628 1.104.628a1.31 1.31 0 0 0 1.298-1.323c0-.238-.06-.461-.167-.655a10.887 10.887 0 0 0-1.747-2.356c-1.972-2-4.386-3.014-7.174-3.014-2.79 0-5.202 1.018-7.168 3.024C1.499 5.357.5 7.818.5 10.664s.998 5.306 2.965 7.312C5.432 19.983 7.843 21 10.634 21c2.788 0 5.202-1.014 7.174-3.014a10.89 10.89 0 0 0 1.747-2.356c.107-.193.167-.416.167-.654a1.31 1.31 0 0 0-1.298-1.324",
  mask: "url(#h)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.421 13.652c-.48 0-.9.251-1.136.628a8.044 8.044 0 0 1-1.39 1.824c-1.526 1.515-3.32 2.25-5.48 2.25-2.163 0-3.955-.735-5.481-2.25-1.527-1.516-2.27-3.294-2.27-5.44 0-2.146.743-3.926 2.27-5.44 1.526-1.515 3.318-2.25 5.48-2.25 2.161 0 3.955.735 5.481 2.25a8.056 8.056 0 0 1 1.39 1.823c.235.377.656.628 1.136.628a1.329 1.329 0 0 0 1.163-1.978 10.927 10.927 0 0 0-1.796-2.356c-2.027-2-4.508-3.014-7.374-3.014-2.868 0-5.346 1.018-7.367 3.024C1.026 5.357 0 7.818 0 10.664s1.026 5.306 3.047 7.312C5.068 19.983 7.547 21 10.414 21c2.866 0 5.347-1.014 7.374-3.014a10.93 10.93 0 0 0 1.796-2.356 1.329 1.329 0 0 0-1.162-1.977",
  mask: "url(#j)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.226 11.594h.001c.822 0 1.488-.664 1.49-1.484l.002-.001C20.594 7.496 19.58 5.225 17.7 3.35 15.69 1.345 13.225.327 10.372.327 7.52.327 5.054 1.345 3.044 3.35 1.034 5.358.013 7.818.013 10.663c0 2.847 1.02 5.307 3.03 7.313C5.055 19.983 7.522 21 10.374 21c2.851 0 5.32-1.02 7.337-3.032.965-.963 1.707-2.04 2.212-3.21a1.325 1.325 0 0 0-1.204-1.89c-.553 0-1.027.336-1.229.815a7.665 7.665 0 0 1-1.665 2.42c-1.518 1.515-3.301 2.252-5.452 2.252-2.15 0-3.933-.737-5.452-2.252-1.293-1.29-2.02-2.772-2.207-4.509h16.513zM4.92 5.224c1.519-1.515 3.302-2.252 5.452-2.252s3.934.737 5.452 2.252c1.096 1.093 1.782 2.319 2.082 3.726H2.84c.3-1.407.986-2.633 2.081-3.726z",
  mask: "url(#l)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(105 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M19.368 11.594h.002c.821 0 1.487-.664 1.489-1.484l.002-.001c-.125-2.613-1.138-4.884-3.017-6.758C15.833 1.345 13.368.327 10.516.327c-2.853 0-5.319 1.018-7.329 3.024C1.176 5.358.156 7.818.156 10.663c0 2.847 1.02 5.307 3.031 7.313C5.197 19.983 7.663 21 10.516 21c2.85 0 5.32-1.02 7.336-3.032a10.319 10.319 0 0 0 2.214-3.21 1.329 1.329 0 0 0-1.205-1.889c-.553 0-1.027.335-1.23.814a7.663 7.663 0 0 1-1.664 2.42c-1.518 1.515-3.302 2.252-5.451 2.252-2.151 0-3.935-.737-5.453-2.252-1.293-1.29-2.02-2.772-2.207-4.509h16.512zM5.063 5.224c1.518-1.515 3.302-2.252 5.453-2.252 2.15 0 3.933.737 5.451 2.252 1.095 1.093 1.782 2.319 2.082 3.726H2.981c.3-1.407.987-2.633 2.082-3.726z",
  mask: "url(#n)"
})));

function SvgLogoCecotec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 25,
    viewBox: "0 0 147 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCecotec);
export default __webpack_public_path__ + "static/media/logo-cecotec.29db6586.svg";
export { ForwardRef as ReactComponent };